import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/es'

// Extender dayjs con plugins necesarios
dayjs.extend(relativeTime)
dayjs.extend(localizedFormat)
dayjs.locale('es')

// Función helper para formatear con formato 'lll' (similar a moment)
function formatLll(date) {
  // Formato: "D MMM YYYY, h:mm A" en español
  // Ejemplo: "20 ene 2026, 3:45 PM"
  return date.format('D MMM YYYY, h:mm A')
}

export default {
  install(Vue) {
    // Hacer dayjs disponible globalmente como $moment (para compatibilidad)
    Vue.prototype.$moment = function(value) {
      const date = value ? dayjs(value) : dayjs()
      
      // Crear un proxy que extienda el método format pero mantenga todo lo demás
      return new Proxy(date, {
        get(target, prop) {
          if (prop === 'format') {
            // Retornar función format extendida
            return function(formatStr) {
              if (formatStr === 'lll') {
                return formatLll(target)
              }
              return target.format(formatStr)
            }
          }
          // Para cualquier otra propiedad, retornar la original
          const value = target[prop]
          if (typeof value === 'function') {
            return value.bind(target)
          }
          return value
        }
      })
    }

    // Filtro 'moment' compatible con vue-moment
    Vue.filter('moment', function(value, format, base) {
      if (!value) return ''
      
      const date = dayjs(value)
      
      if (!date.isValid()) return value
      
      // Si el formato es 'from', usar relativeTime
      if (format === 'from' && base) {
        return date.from(dayjs(base))
      }
      
      // Si hay un formato, aplicarlo
      if (format) {
        // Mapear formatos de moment a dayjs
        if (format === 'lll') {
          return formatLll(date)
        }
        return date.format(format)
      }
      
      return date.format()
    })
  }
}
